import { EventService } from "./event-service";
import * as Consts from "../ts/rlAdmin.consts";
import * as NProgress from "nprogress";
import { StringUtil } from "../ts/rlAdmin.utils";
/*
 * Handles UI notification throughout site
 */
export class NotifyService {
    static $inject = ["$q", "eventService"];

    // stack for keeping track of nested sequences
    stack: Array<boolean>;

    errorResponseHandler: (reason: ng.IHttpPromiseCallbackArg<any>) => ng.IPromise<any>;

    constructor(private $q: ng.IQService, private eventService: EventService) {
        this.stack = [];

        this.errorResponseHandler = (reason: ng.IHttpPromiseCallbackArg<any>) => {
            this.notifyError("Error: " + reason.statusText);
            return this.$q.reject();
        }


        //set default gritter options
        $.extend($.gritter.options, {
            _tpl_close: '<a class="gritter-close" href="#" tabindex="1"></a>',
            position: "bottom-right",	// bottom right location
            time: 2000					// 2 seconds
        });

        NProgress.configure({ speed: 0 });
    }

    /*
     * start progress bar (nestable)
     */
    startProgress() {
        // only start progress if context stack count == 0
        //clk 9/22/2104 - temporarily commenting out progress bar until we can resolve performance issues
        if (this.stack.length == 0) {
            NProgress.start();
            this.eventService.call(Consts.Events.NotifyStart);
        }
        // push context stack
        this.stack.push(true);
    }

    /*
     * end progress bar (nestable)
     */
    endProgress(force: boolean = false) {
        // pop context;
        //clk 9/22/2104 - temporarily commenting out progress bar until we can resolve performance issues
        var context = this.stack.pop();
        if (force) {
            this.stack = [];
        }
        // only stop progress if last context was popped
        if (context === undefined || this.stack.length == 0) {
            NProgress.done();
            this.broadcastDone();
        }
    }

    /*
     * notify success message in UI
     */
    notifySuccess(text: string): void {
        $.gritter.add({ title: "<i class='fa fa-check'></i> Success", text: StringUtil.escapeHtml(text), class_name: "success" });
        //$.noty({ layout: 'topRight', type: 'success', text: text });
    }

    /*
     * notify error message in UI
     */
    notifyError(text: string): void {
        $.gritter.add({ title: "<i class='fa fa-times'></i> Error", text: StringUtil.escapeHtml(text), class_name: "danger" });
        //$.noty({ layout: 'topRight', type: 'error', text: text });
    }

    /*
     * notify into message in UI
     */
    notifyInfo(text: string): void {
        $.gritter.add({ title: "<i class='fa fa-info'></i> Information", text: StringUtil.escapeHtml(text), class_name: "info" });
        //$.noty({ layout: 'topRight', type: 'info', text: text });
    }

    // broadcasts (only) done message for any dependent components
    broadcastDone() {
        this.eventService.call(Consts.Events.NotifyDone);
    }
}